// extracted by mini-css-extract-plugin
module.exports = {"app-seperator":"seperator-block_app-seperator__g_O9G"};